import AppSettings from "../Settings/AppSettings";
import { SORT } from "Pages/GMS/Products/constants";

class Utils {
  static isEmpty(value) {
    return (
      value === null || value === undefined || value.toString().trim() === ""
    );
  }

  static getListFromCommaSeparatedString(str) {
    if (this.isEmpty(str)) return [];
    return str.split(",");
  }

  static toTimestamp(strDate) {
    const dt = Date.parse(strDate);
    return dt / 1000;
  }

  static getUTCDateString(d) {
    function pad(n) {
      return n < 10 ? "0" + n : n;
    }
    return (
      d.getUTCFullYear() +
      "-" +
      pad(d.getUTCMonth() + 1) +
      "-" +
      pad(d.getUTCDate()) +
      "T" +
      pad(d.getUTCHours()) +
      ":" +
      pad(d.getUTCMinutes()) +
      ":" +
      pad(d.getUTCSeconds())
    );
  }

  static getDate(dateString) {
    const date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");

    return month + "/" + day + "/" + year;
  }

  static convertStringDateToFullDate(dateString) {
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    let hours = date.getHours().toString().padStart(2, "0");
    let minutes = date.getMinutes().toString().padStart(2, "0");
    let seconds = date.getSeconds().toString().padStart(2, "0");

    return (
      month +
      "/" +
      day +
      "/" +
      year +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds
    );
  }

  static convertStringDateToUTCWithUTCTime(dateString) {
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    let hours = date.getUTCHours().toString().padStart(2, "0");
    let minutes = date.getUTCMinutes().toString().padStart(2, "0");
    let seconds = date.getUTCSeconds().toString().padStart(2, "0");
    // const year = date.getUTCFullYear();
    // const month = date.getUTCMonth() + 1;
    // const day = date.getUTCDate().toString().padStart(2, "0");
    // const time = date.getUTCHours() + ":" + date.getUTCMinutes();
    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  }

  static convertStringDateToUTC(dateString) {
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    let hours = date.getHours().toString().padStart(2, "0");
    let minutes = date.getMinutes().toString().padStart(2, "0");
    let seconds = date.getSeconds().toString().padStart(2, "0");

    // const year = date.getUTCFullYear();
    // const month = date.getUTCMonth() + 1;
    // const day = date.getUTCDate().toString().padStart(2, "0");
    // const time = date.getUTCHours() + ":" + date.getUTCMinutes();

    return `${day} / ${month} / ${year} ${hours}:${minutes}:${seconds}`;
  }

  static round(num) {
    if (this.isUndefinedOrNull(num)) return null;
    if (this.isEmpty(num)) return null;
    var m = Number((Math.abs(num) * 100).toPrecision(15));
    return (Math.round(m) / 100) * Math.sign(num);
  }

  static isUndefinedOrNull(value) {
    return value === null || value === undefined;
  }

  static replace_all(str, findchar, replacechar) {
    return str.split(findchar).join(replacechar);
  }
  static capitalizeFirstLetter(str) {
    const words = str.split(" ");

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    return words.join(" ");
  }
  static appendLeadingZeroes(n) {
    if (n <= 9) {
      return "0" + n;
    }
    return n;
  }

  static get_current_root_url() {
    return window.location.origin + "/";
  }

  static get_current_route_url() {
    return window.location.href;
  }

  static isNumeric(num) {
    return !isNaN(num);
  }

  static get_environment(envid) {
    let tempVar = JSON.parse(JSON.stringify(AppSettings.SERVER_ENVIRONMENTS));
    let envitem = tempVar.filter((p) => p.id === envid);
    if (envitem.length === 1) return envitem[0];
    return null;
  }
  static get_environment_name(envid) {
    let env = this.get_environment(envid);
    if (env === null) return null;
    return env.name;
  }

  static get_environment_btnClass(envid) {
    let env = this.get_environment(envid);
    if (env === null) return null;
    return env.btnClass;
  }

  static get_environment_badgeClass(envid) {
    let env = this.get_environment(envid);
    if (env === null) return null;
    return env.badgeClass;
  }

  static async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  static SetWindowTitle(title) {
    window.document.title = "SMARTSTUDIO : " + title;
    // window.document.title = "GMS : " + title;
  }

  static enableFeatherPlugin() {
    window["ProcessFeatherPlugins"]();
    this.ProcessToolTips();
  }

  static OpenTheModal(id) {
    window["OpenTheModal"](id);
  }

  static ProcessToolTips(id) {
    window["ProcessToolTips"]();
  }

  static run_initial_js() {
    //window["run_initial_js"]();
  }

  static to_datatable(tableid) {
    window["to_datatable"](tableid);
  }

  static handle_collapse_icon(elementid) {
    window["handle_collapse_icon"](elementid);
  }

  static generate_guid() {
    var dt = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  }

  static reload_frame(frameid) {
    window["reload_frame"](frameid);
  }

  static check_frame_is_loaded(frameid, callbackmethod) {
    window["check_frame_is_loaded"](frameid, callbackmethod);
  }

  static click_button(buttonid) {
    window["click_button"](buttonid);
  }

  static borderStyle() {
    return { height: "2.6875rem", border: "1px solid #c9cccf" };
  }

  static generate_file_name(length) {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  static run_callback_on_click_outside_ref(e, ref, callback){
    if(ref.current && !ref.current.contains(e.target)) callback()
  }

  /**
   * Validate form fields
   * 
   * @param {object} fields 
   * @param {object} options
   * 
   * ----------------------------------------------------------------
   * 
   * *example*: 
   * Utils.validate(
   * fields,
   * options = {
   * name: {required: true, minLength: 2, maxLength: 65, type: "alphanumeric"}
   * }
   * )
   * 
   * options: 
   * required: boolean,
   * minLength: number,
   * maxLength: number,
   * type: alnum_with_spaces|alnum|number
   * 
   * ----------------------------------------------------------------
   * @returns {boolean}
   */
  static validate(
    fields, 
    options = null
  ){
    if(!fields || !options) return true
    let flag = [true, ""]
    const alphanumeric = /^[\w\s-\[\]\(\)]+$/; // alphanumberic regex
    const numeric = /^\d+$/

    Object.entries(options).map(([fieldName, option], key) => {
      const fieldValue = fields[fieldName] 
  
      if(option.required && (!fieldValue || (typeof fieldValue == "string" && fieldValue?.trim() == "") || fieldValue?.length === 0)) 
        flag = [false, `${fieldName} is required`]
  
      else if(option.type === "alnum_with_spaces" && (!alphanumeric.test(fieldValue) || numeric.test(fieldValue))) 
        flag = [false, `${fieldName} should be alphanumeric with spaces, no special characters allowed`]
  
      else if(option.type === "alnum" && fieldValue && (!alphanumeric.test(fieldValue) || numeric.test(fieldValue))) 
        flag = [false, `${fieldName} should be alphanumeric, no special characters or spaces allowed`]
  
      else if(option.type === "number" && fieldValue && (!numeric.test(fieldValue))) 
        flag = [false, `${fieldName} should be a number`]
  
      if(option.minLength && fieldValue?.length < option.minLength) 
        flag = [false, `${fieldName} should atleast contain ${option.minLength} characters`]
  
      if(option.maxLength && fieldValue?.length > option.maxLength) 
        flag = [false, `${fieldName} should be less than ${option.maxLength} characters`]
    })
  
    return flag
  }

  static generateHeadersFromArray(arr){
    return arr.reduce((acc, item) => [...acc, {name: item, column: item}], [])
  }

  static sortChoices (
    sort,
    type,
    getNameCallBack,
    disabledCallback,
    ) {
      if(!sort) return () => true
      return (item1, item2) => {
        const a = getNameCallBack(item1).replace('"', '').split(' ')[0]
        const b = getNameCallBack(item2).replace('"', '').split(' ')[0]
        if(type === SORT.SEPERATE_ASC || !type)
          return (
              (disabledCallback && (disabledCallback(item1)) - (disabledCallback(item2))) || // disabled
              ((!isNaN(+a) && !isNaN(+b)) ? +a - +b : 0) || // if both are number
              ((!isNaN(+a) && isNaN(+b)) && 0) || // if 1st is number
              (isNaN(+a) && !isNaN(+b) && 1) || // if 2nd is number
              (isNaN(+a) && isNaN(+b) && a.localeCompare(b) || 0 // if both are string
          ))
        if(type === SORT.SEPERATE_DESC)
          return (
            (disabledCallback && (disabledCallback(item1)) - (disabledCallback(item2))) || // disabled
            ((!isNaN(+a) && !isNaN(+b)) ? +b - +a : 0) || // if both are number
            ((!isNaN(+a) && isNaN(+b)) && 1) || // if 1st is number
            (isNaN(+a) && !isNaN(+b) && 0) || // if 2nd is number
            (isNaN(+a) && isNaN(+b) && b.localeCompare(a) || 0 // if both are string
          ))
        if(type === SORT.ASC)
          return (
            ((!isNaN(+a) && !isNaN(+b)) ? +a - +b : 0) || // if both are number
            ((!isNaN(+a) && isNaN(+b)) && 0) || // if 1st is number
            (isNaN(+a) && !isNaN(+b) && 1) || // if 2nd is number
            (isNaN(+a) && isNaN(+b) && a.localeCompare(b) || 0 // if both are string
          ))
        if(type === SORT.DESC)
          return (
            ((!isNaN(+a) && !isNaN(+b)) ? +b - +a : 0) || // if both are number
            ((!isNaN(+a) && isNaN(+b)) && 1) || // if 1st is number
            (isNaN(+a) && !isNaN(+b) && 0) || // if 2nd is number
            (isNaN(+a) && isNaN(+b) && b.localeCompare(a) || 0 // if both are string
          ))
        }

      }


    static generateFiltersFromObject(filters) {
      if(!filters) return

      return Object.keys(filters)
      .filter((key) => !!filters[key])
      .map(key => key + '=' + (typeof filters[key] !== 'object' ? filters[key] : (filters[key].toString()))).join('&')
    }


    static getDeltaValue({live, draft, rollback}) {
      if (live != null)
          return {...live, delta_type: "live"};

      if (draft != null)
          return {...draft, delta_type: "draft"};

      if (rollback != null)
          return {...rollback, delta_type: "rollback"};
  }
}


export default Utils;

export const compareSortNumbers = (propName) => {
  return function (a, b) {
    if (a[propName]) {
      if (a[propName] < b[propName]) return -1;
      if (a[propName] > b[propName]) return 1;
      return 0;
    } else {
      if (a[propName] < b[propName]) return -1;
      if (a[propName] > b[propName]) return 1;
      return 0;
    }
  };
  
};


